"use strict";exports.__esModule = true;exports.symbol = symbol;function symbol() {
  // eslint-disable-next-line max-len,quotes
  return '<symbol viewbox="0 0 24 24" id=icon-carousel-next><path d="M17.707 11.293a1 1 0 0 1 .22.33l-.22-.33Zm-.001-.001-7.999-8a1 1 0 0 0-1.414 1.415L15.586 12l-7.293 7.293a1 1 0 1 0 1.414 1.414l8-8a.999.999 0 0 0 .22-1.083"></path></symbol>';
}